var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.css.burger] = true, _obj[_vm.css.isToggled] = _vm.isToggled, _obj ),attrs:{"aria-label":((_vm.isToggled ? 'закрыть' : 'открыть') + " меню навигации"),"role":"button"}},[_c('div',{class:_vm.css.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }